import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const SubSuccessProvider = styled('div', {
  maxWidth: '335px',
  fontSize: '18px',
  color: '#323334',
  fontWeight: '700',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '@media (max-width: 744px)': {
    maxWidth: '235px',
  },
});

export const SubSuccessProviderSpeciality = styled('div', {
  color: '#4B4D4F',
  fontSize: '14.22px',
  '@media (max-width: 744px)': {
    fontSize: '12.64px',
  },
});

export const SuccessPageYourPCPHeader = styled(Flex, {
  alignContent: 'flex-start',
  alignItems: 'center',
  direction: 'row',
  '@media (max-width: 464px)': {
    marginTop: '24px',
  },
});

export const SuccessPageYourPCPLocationHeader = styled('div', {
  marginTop: '24px',
  '@media (max-width: 464px)': {
    marginTop: '32px',
  },
});

export const SuccessPageBackButton = styled(Button, {
  '&.abyss-button-root': {
    width: 'auto',
    height: '42px',
    padding: '0 16px 0 24px',
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '600',
  },
});

export const SuccessMessageHeading = styled('div', {
  marginLeft: '12px',
  h1: {
    color: '$core.color.brand.100',
    margin: '0px',
    lineHeight: '44px',
    '@media (max-width: 464px)': {
      fontSize: '28.83px',
      lineHeight: '36px',
      width: '299px',
      marginBottom: '8px',
      maxHeight: '72px',
    },
  },
  span: {
    color: '$core.color.brand.100',
    fontSize: '18px',
    fontWeight: '$medium',
    lineHeight: '24px',
    '@media (max-width: 464px)': {
      fontSize: '$md',
      lineHeight: '20px',
    },
  },
});

export const SuccessPageWrapColumn = styled('div', {
  height: '632px',
  position: 'absolute',
  display: 'inline-block',
  overflow: 'visible',
  backgroundColor: '$core.color.neutral.0',
  zIndex: 10,
  boxShadow: '10px 0px 5px -5px rgba(0, 0, 0, 0.2)',
  paddingRight: '$lg',
  width: '432px',
  paddingTop: '24px',
  '@media (min-width: 465px)': { maxWidth: '432px' },
  '@media (max-width: 464px)': {
    width: '100%',
    height: '532px',
    boxShadow: 'unset',
    padding: '0',
  },
});

export const SuccessMapViewWrap = styled('div', {
  dynamic: ({ cssProps: { closeSidePanel } = {} }) => ({
    '.abyss-card-root': {
      width: closeSidePanel ? '100%' : 'calc(100% - 400px)',
      marginLeft: closeSidePanel ? '0' : '400px',
    },
  }),
  '.abyss-card-root': {
    height: '632px',
    width: '100%',
    border: 'none',
    boxShadow: 'unset',
    '.map-container': {
      height: '632px',
      width: '100%',
    },
  },
  '@media (max-width: 464px)': {
    '.abyss-card-root ': {
      height: '532px',
      width: '100vw',
      marginLeft: '0 !important',
      '.map-container': {
        height: '532px',
        width: '100vw',
      },
    },
  },
  '.mapboxgl-ctrl-bottom-left': {
    display: 'none',
  },
  '.mapboxgl-ctrl-bottom-right': {
    display: 'none',
  },
});

export const ChooseLocationCardsSuccessContainer = styled('div', {
  dynamic: ({ cssProps: { isListSaved } = {} }) => ({
    maxHeight: isListSaved ? 'unset' : '632px',
  }),
  maxWidth: '432px',
  gap: '12px',
  '.location-cards-wrapper': {
    width: '100%',
  },
  '@media (max-width: 464px)': {
    marginRight: 0,
    maxHeight: '500px',
    '&.abyss-box-root': {
      display: 'flex',
    },
  },
});

export const PCPHeaderContainer = styled('div', {
  backgroundColor: '#FBFCFE',
  borderBottom: 'solid #E5E5E6',
});

export const ContentWrapperFullWidth = styled('div', {
  marginLeft: 'calc((100vw - 1200px)/2)',
  padding: '24px 0',

  '@media (max-width: 1920px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1440px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1230px)': {
    marginLeft: '24px',
  },
  '@media (max-width: 464px)': {
    marginLeft: '12px',
  },
});

export const LocationWrapperFullWidth = styled('div', {
  marginLeft: 'calc((100vw - 1200px)/2)',

  '@media (max-width: 1920px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1440px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1230px)': {
    marginLeft: '24px',
  },
  '@media (max-width: 464px)': {
    marginLeft: '12px',
  },
});

export const SuccessSelectedPCPBox = styled('div', {
  '&.abyss-box-root': {
    padding: '0',
    '@media (max-width: 464px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      maxHeight: '132px',
      minHeight: '132px',
    },
  },
});

export const LocationsDropdown = styled('div', {
  border: '1px solid $neutralGray4',
  boxSizing: 'border-box',
  alignItems: 'center',
  padding: '0px 0px 0px 8px',
  background: 'white',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
  borderRadius: '12px',
  '@media (max-width: 464px)': {
    width: '100%',
  },
  borderColor: '$core.color.green.100',
  dynamic: ({ cssProps: { removeTruncatedDataCard } = {} }) => ({
    height: removeTruncatedDataCard ? 'auto' : '64px',
    padding: removeTruncatedDataCard ? '12px' : '0px 0px 0px 8px',
    alignItems: removeTruncatedDataCard ? 'flex-start' : 'center',
  }),
});

export const ClinicNameAddress = styled('div', {
  border: '1px solid $neutralGray4',
  boxSizing: 'border-box',
  alignItems: 'center',
  padding: '8px 16px 8px 16px',
  background: 'white',
  borderRadius: '12px',
  '@media (max-width: 464px)': {
    padding: '$sm 0 $sm $md',
    width: '100%',
  },
  borderColor: '$core.color.green.100',
});

export const ContentContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  '@media (max-width: 464px)': {
    alignItems: 'flex-start',
  },
});

export const SuccessCheckMark = styled('div', {
  display: 'flex',
  '@media (max-width: 464px)': {
    marginTop: '0px',
  },
});

export const TextContainer = styled('div', {
  maxWidth: '300px',
});

export const ChoosePCPPhoto = styled(Flex, {
  '&.abyss-flex-root': {
    color: '#CBCCCD',
    marginTop: '8px',
    width: '45px',
    height: '45px',
    minWidth: '45px',
    minHeight: '45px',
    borderRadius: '50%',
    overflow: 'hidden',
    marginRight: '8px',
    '@media (max-width: 464px)': {
      width: '46.67px',
      height: '46.67px',
      minWidth: '46.67px',
      minHeight: '46.67px',
    },
  },
});

export const LocationWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});
